import * as actionsType from "../actions/types";

const initialState = {
  subCategories: [],
  subCategoryFields: [],
};

export default function subcategory(state = initialState, { payload, type }) {
  const tempState = { ...state };
  switch (type) {
    case actionsType.UPDATE_SUBCATEGORIES:
      return { ...state, subCategories: payload, };

    case actionsType.UPDATE_SUBCATEGORY_FIELDS:
      return { ...state, subCategoryFields: payload, };
    // case actionsType.LOGOUT_SUCCESS:
    //   console.log("Initial State on logout", initialState);
    //   return { ...initialState };

    case actionsType.EDIT_SUB_CATEGORY:
      const { editId, name, categoryId } = payload;
      let editIndex = state.subCategories.findIndex(i => i._id === editId);
      tempState.subCategories[editIndex].categoryId = categoryId;
      tempState.subCategories[editIndex].name = name;
      return { ...state, tempState };

    case actionsType.DEL_SUB_CATEGORY:
      // alert(JSON.stringify(action.payload))
      const { id } = payload;
      let index = state.subCategories.findIndex(i => i._id === id);
      state.subCategories.splice(index, 1)
      return { ...state, };

    case actionsType.ADD_SUB_CATEGORY:
      state.subCategories = [...state.subCategories, payload]
      return { ...state };



    default:
      return state;
  }
}
